export const notificationTypes = [
    "follow",
    "mention",
    "reply",
    "renote",
    "quote",
    "reaction",
    "pollVote",
    "pollEnded",
    "receiveFollowRequest",
    "followRequestAccepted",
    "app",
];
export const noteVisibilities = [
    "public",
    "home",
    "followers",
    "specified",
];
export const mutedNoteReasons = ["word", "manual", "spam", "other"];
export const ffVisibility = ["public", "followers", "private"];
export const permissions = [
    "read:account",
    "write:account",
    "read:blocks",
    "write:blocks",
    "read:drive",
    "write:drive",
    "read:favorites",
    "write:favorites",
    "read:following",
    "write:following",
    "read:messaging",
    "write:messaging",
    "read:mutes",
    "write:mutes",
    "write:notes",
    "read:notifications",
    "write:notifications",
    "read:reactions",
    "write:reactions",
    "write:votes",
];
//# sourceMappingURL=consts.js.map